<span *ngIf="isSaving">
    <div class="row">
    <div class="col-xs-12">
        <br />
        <span><em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em> &nbsp;Salvando Ficha Proposta...</span>
    </div>
    </div>
</span>

<span *ngIf="!isSaving">
    <h2>Análise</h2>
    <div class="row">
        <div class="col-xs-12">
            <div class="panel blue analisys">
                <span class="icon check"></span>
                    <h3>A solicitação foi finalizada<br>e enviada para análise</h3>
                <div class="darkblue">
                    <span class="icon direct-analysis"></span>
                    <span class="text"><strong>Análise Direta</strong>Espera Máxima: 45 min</span>
                </div>
            </div>
            <div class="panel costumer">
                <span class="icon user"></span>
                <div class="content">
                    <h3>Cliente</h3>
                    <p>{{ nomeCliente }}</p>
                    <p>CPF: {{ cpfCliente | cpf }}</p>
                </div>
            </div>
            <div class="panel costumer">
                <span class="icon car"></span>
                <div class="content">
                    <h3>Veículo Escolhido</h3>
                    <p>{{ descMarcaModelo }} - {{ anoModelo }}</p>
                </div>
            </div>
            <div class="panel costumer">
                <span class="icon payment"></span>
                <div class="content">
                    <h3>Condições</h3>
                    <p>R$ {{ valorLiquido | number:'1.2-2' }} ({{ qtdParcelas }}x R$ {{ valorParcela | number:'1.2-2' }})</p>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <br>
        <div class="clean-panel text-center">
            <div class="marginT30 tab-buttons bt-home" *ngIf="!isLojista() && isRefinanciamento()">
                <a (click)="abrirModalDadosFavorecido()" class=" btn btn-border-orange">Apontar Dados do Favorecido</a>
            </div>
            <br />
            <p>Agora é só aguardar os próximos passos!
                <br> Informaremos os próximos passos do processo.</p>
        </div>
    </div>
    <div class="row">
        <div class="marginT30 tab-buttons bt-home">
            <a routerLink="/ficha" class=" btn btn-full-orange">OK, ir para home </a>
        </div>
    </div>
</span>

<app-modal #modalDadosFavorecido title="DADOS DO FAVORECIDO" labelOk="Salvar" labelClose="Cancelar" message="Deseja cancelar o preenchimento e retornar a conclusão da ficha?" [ignoreBackdropClick]="true"
 [keyboard]="false" [disabledOk]="!form.valid || !isFormValid()">
    <form #form="ngForm" class="forms">
        <div class="col-xs-12">
           <app-form-group icon="user" label="Favorecido" labelFor="codigoDestino">
                <select class="form-control" id="codigoDestino" name="codigoDestino" [(ngModel)]="dadosFavorecido.codigoDestino" appShowErrorMessages required>
                   <option value="undefined" hidden selected>Selecione o Favorecido...</option>
                    <option value="1">1 - Agente</option>
                    <option value="2">2 - Cliente</option>
                    <option value="3">3 - Origem</option>
                    <option value="4">4 - Terceiro</option>
                </select>
            </app-form-group>

            <app-form-group label="Nome" labelFor="nomeTitular">
                <input type="text" class="form-control" id="nomeTitular" [(ngModel)]="dadosFavorecido.nomeTitular" placeholder="Digite o nome do favorecido" name="nomeTitular" appOnlyLetter appTextUppercase appShowErrorMessages required  minlength="4" maxlength="60" />
            </app-form-group>

            <app-form-group icon="id-number" label="CPF/CNPJ" labelFor="cpfCnpj">
                <input id="cpfCnpj" name="cpfCnpj" [(ngModel)]="dadosFavorecido.cpfCnpj" placeholder="Digite o CPF/CNPJ do favorecido" type="text" class="form-control" maxlength="18" appCpfCnpjValidator appCpfCnpj appShowErrorMessages required />
            </app-form-group>

            <app-form-group icon="bank" label="Banco" labelFor="banco">
                <app-custom-select [items]="bancos" (itemChange)="dadosFavorecido.banco = $event"></app-custom-select>
            </app-form-group>

            <app-form-group label="Agência/dig." labelFor="agencia">
                <div class="input-box group-input">
                    <div id="agencia">
                        <input minlength="3" maxlength="8" type="text" name="agencia" [(ngModel)]="dadosFavorecido.agencia"  placeholder="Agência" class="form-control" appShowErrorMessages required/>
                    </div>
                    <div id="digitoAgencia">
                        <input minlength="1" maxlength="2" type="text" name="digitoAgencia" [(ngModel)]="dadosFavorecido.digitoAgencia" placeholder="DV" class="form-control" appShowErrorMessages required/>
                    </div>
                </div>
            </app-form-group>

            <app-form-group label="Conta Corrente/dig." labelFor="contaCorrente">
                <div class="input-box group-input">
                    <div id="contaCorrente">
                        <input minlength="3" maxlength="20" type="text" name="contaCorrente" [(ngModel)]="dadosFavorecido.contaCorrente" placeholder="Conta Corrente" class="form-control" appShowErrorMessages required  />
                    </div>
                    <div id="digitoContaCorrente">
                        <input minlength="1" maxlength="2" type="text" name="digitoContaCorrente" [(ngModel)]="dadosFavorecido.digitoContaCorrente"  placeholder="DV" class="form-control" appShowErrorMessages required/>
                    </div>
                </div>
            </app-form-group>
        </div>
    </form>
</app-modal>

<app-modal-loader #modalLoader></app-modal-loader>

<app-modal-message [hideClose]="true" #modalMessage title="Atenção"></app-modal-message>

